//资源库首页存储空间

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Tabs, Modal} from 'antd';
import BaseComponent from "../../../../../base/BaseComponent";
import echarts from 'echarts'
import liquidfill from 'echarts-liquidfill'
import ReactEcharts from "echarts-for-react";

const { TabPane } = Tabs;

export default class Storagespace  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            tabList:[{type:'all', name:'全部资源'},{type:'dept', name:'单位资源'}],
            data:{},
            surplus:'',
            currentType:'all'

        }
    }

    componentWillMount() {
    }
    componentDidMount() {
        this.getData();

    }

    render() {

        return(
            <div className={'tabList'}  style={{width:' 38%',height: '428px',background: '#FFFFFF', borderRadius: "10px",marginLeft:'2%'}}>
                <Tabs tabBarStyle={{padding:'0px 10px'}}  activeKey={this.state.currentType}  onChange={(value) => this.handleChange(value)}>
                    {this.state.tabList&&this.state.tabList.length&&this.state.tabList.map((item,index)=>{
                        return(
                            <TabPane tab={item.name}   key={item.type} ></TabPane>
                        )
                    })}
                </Tabs>
                <div style={{width:250,height:250,margin:'61px auto',position: "relative"}}>
                    <div id="shuiboqiu" style={{width:250,height:250}}></div>
                    <div style={{position: "absolute",top:'50px',left:'88px',color:'rgba(0, 0, 0, 0.4500)',fontSize:'12px'}}>
                        存储空间剩余
                    </div>
                    <div style={{marginTop:'20px',color:'rgba(0, 0, 0, 0.4500)',fontSize:'14px',textAlign: 'center'}}>
                        <span>储存空间：{this.state.data.availableSize}GB</span>
                        <span style={{marginLeft:'20px'}}>已储存：{this.getNum(this.state.data.occupationSize)}GB</span>
                    </div>
                </div>
            </div>
        )
    }
    //切换事件
    handleChange(value){
       this.setState({currentType:value},()=>{
           this.getData()
       })
    }

    shuiBoQiuchers(id,data,surplus) {
        var chartDom = document.getElementById(id);
        if (null != chartDom) {
            var myChart = echarts.init(chartDom);
            var option = {
                backgroundColor: '#ffffff',
                series: [
                    {
                        type: 'liquidFill',
                        radius: '99%',
                        center: ['50%', '50%'],
                        data: data,
                        color: ['rgba(4, 138, 255, 0.1)','rgba(4, 138, 255, 0.3)','rgba(4, 138, 255, 0.85)',,'rgba(4, 138, 255, 1)'],//设置波形颜色
                        backgroundStyle: {
                            borderColor: '#048AFF ',
                            borderWidth: 1,
                            color: 'white'//背景色
                        },
                        waveLength: '85%',
                        amplitude: 5,//波浪的幅度
                        itemStyle: {
                            shadowBlur: 0
                        },
                        label: {
                            normal: {
                                formatter: function (value) {
                                    return  surplus  + '%';
                                },
                                textStyle: {
                                    fontSize: 24,
                                    color: '#000'
                                },
                                position: ['50%', '40%'],
                            }
                        },
                        outline: {
                            show: false,
                        }
                    },
                ]
            }
            option && myChart.setOption(option);
        }
    }
     getNum(num) {

        return Math.round(num*100)/100
    }
    //获取类型
    getData() {
        this.request({
            url: "/cm-sites-storage-management/home/queryMemory",
            method: "get",
            body: {
                type:this.state.currentType
            },

            callBack: (data) => {
                if(data){
                    let array= [];
                    let  num =  this.getNum(data.occupationSize?data.occupationSize:0);
                    let residue =  data.availableSize - (data.occupationSize?data.occupationSize:0);
                    let surplus =  this.getNum((residue/data.availableSize)*100);
                    for (let i=0; i<4; i++) {
                        let a = 0;
                        if(num - i > 0){
                            a = num - i/10
                        }else{
                            a = 0
                        }
      
                        array.push(this.getNum(a/data.availableSize))
                    }
                    this.setState({data:data,array:array,surplus:surplus},()=>{
                        this.shuiBoQiuchers("shuiboqiu", this.state.array,this.state.surplus);
                    });

                }
            }

        });
    }

}
